
import HederaHashgraph from "../../../assets/outline/HederaHashgraph.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HederaHashgraphIcon({ className, dataTestid = "HederaHashgraphIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HederaHashgraph data-testid={dataTestid} className={classes} {...rest} />
  );
}
